import {
  Box,
  Button,
  LinearProgress,
  TextField,
  Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';
import pallet from '../../../layouts/pallet';
import { fontSizes } from '../../../layouts/fontSizes';
import DropdownSelect from '../../../components/DropdownSelect';

const ActionsContainer = styled(Box)`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  justify-content: flex-end;
`;

const RoundedButton = styled(Button)`
  border-radius: 8px !important;
  width: 170px !important;
`;

const FiltersContainer = styled(Box)`
  display: flex;
  gap: 16px;
  align-items: flex-end;
  width: 100%;
  flex-wrap: wrap;
`;

const FilterColumn = styled(Box)`
  display: flex;
  flex-direction: column;
`;

const FilterLabel = styled(Typography)`
  font-weight: 500 !important;
  margin-left: 4px !important;
  color: ${pallet.formLabelText};
  font-size: ${fontSizes.placeHolder} !important;
`;

const StyledTextField = styled(TextField)`
  width: 100% !important;
  max-width: 170px !important;
`;

const SearchButton = styled(Button)`
  border-radius: 8px !important;
  width: 170px !important;
`;

const SearchButtonBox = styled(Box)<{ isWrapped?: boolean }>(
  ({ isWrapped }) => ({
    display: 'flex',
    alignItems: 'flex-end',
    flexGrow: 1,
    justifyContent: isWrapped ? 'flex-start' : 'flex-end'
  })
);

const CustomDropdownSelect = styled(DropdownSelect)`
  margin: 0px !important;
`;

const StyledLinearProgress = styled(LinearProgress)({
  marginBottom: 8
});

const GridContainer = styled(Box)`
  width: 100%;
`;

const PageHeader = styled(Typography)`
  font-size: 24px !important;
  font-weight: 600 !important;
  margin-left: 3% !important;
  margin-top: 16px !important;
`;

const EnrollmentTypography = styled(Typography)(() => ({
  color: pallet.aqua,
  textDecoration: 'underline',
  textDecorationColor: pallet.aqua
}));

const NameTypography = styled(Typography)(() => ({
  fontSize: 14
}));

const PageContainer = styled(Box)({});

export {
  ActionsContainer,
  RoundedButton,
  FiltersContainer,
  FilterColumn,
  FilterLabel,
  StyledTextField,
  SearchButton,
  SearchButtonBox,
  GridContainer,
  StyledLinearProgress,
  PageHeader,
  EnrollmentTypography,
  NameTypography,
  PageContainer,
  CustomDropdownSelect
};
